module.exports = __webpack_public_path__ + "sansg/img/ban.24addaa1.png";